import CalculatorSummary from './CalculatorSummary'
import StudyProgramSelector from './StudyProgramSelector'
import { MessageCircleQuestion as IconMessageCircleQuestion } from 'lucide-react'
import useOpenIntercomChat from '@/hooks/useOpenIntercomChat'
import ShareCalculations from './ShareCalculations'

const ScoreCard = ({ showImproveGrades }: { showImproveGrades: boolean }) => {
  const handleOpenIntercomChat = useOpenIntercomChat()

  return (
    <div className="bg-white shadow-sm-soft rounded-xl pt-7" data-testid="score-card">
      <CalculatorSummary type={showImproveGrades ? 'improved' : 'unimproved'} />
      <div className="px-7 pb-7 pt-4" data-testid="study-program-section">
        <StudyProgramSelector />
      </div>
      <div className="px-7 py-5 bg-warm-gray-50 rounded-b-xl flex items-center justify-between gap-2" data-testid="score-card-footer">
        <button
          className="flex items-center gap-2 cursor-pointer hover:text-purple-700 group"
          onClick={handleOpenIntercomChat}
          data-testid="chat-advisor-button"
        >
          <IconMessageCircleQuestion className="size-5 text-warm-gray-700 group-hover:text-inherit" />
          <span className="text-sm font-semibold">Chat med rådgiver</span>
        </button>
        <ShareCalculations />
      </div>
    </div>
  )
}

export default ScoreCard
